import useViewContext from '/druid/internal/useViewContext';

export default function useScrollBarWidth() {
  const { scrollBarWidth } = useViewContext();

  return [scrollBarWidth];
}
